<template>
  <v-dialog
    v-if="showDialog"
    :value="value"
    persistent
    max-width="750"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title>
        <v-layout align-center>
          <v-flex
            shrink
            mr-3
          >
            <v-icon size="60px">
              error
            </v-icon>
          </v-flex>
          <v-flex shrink>
            <p class="mb-0 display-3 display-3_dark text-xs-left">
              {{ $t('similar_families.title') }}
            </p>
            <p class="mb-0 f-16 sz_grafit--text ma-0 font-weight-regular">
              {{ $t('similar_families.subtitle') }}
            </p>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout justify-center>
          <v-flex>
            <v-layout mt-3>
              <v-flex
                xs4
                sm3
              >
                <p class="text-xs-left f-16 sz_grafit--text ma-0 mr-3 font-weight-bold">
                  {{ $t('similar_families.author') }}
                </p>
              </v-flex>
              <v-flex shrink>
                <p class="text-xs-left f-16 sz_grafit--text ma-0">
                  {{ fullName }}
                </p>
                <p class="text-xs-left f-16 sz_grafit--text ma-0">
                  {{ email }}
                </p>
              </v-flex>
            </v-layout>
            <v-layout mt-3>
              <v-flex
                xs4
                sm3
              >
                <p class="text-xs-left f-16 sz_grafit--text ma-0 mr-3 font-weight-bold">
                  {{ $t('similar_families.region') }}
                </p>
              </v-flex>
              <v-flex shrink>
                <p class="text-xs-left f-16 sz_grafit--text ma-0">
                  {{ locationNameByWioStruct }}
                </p>
              </v-flex>
            </v-layout>
            <v-layout
              v-if="locationLeaders && locationLeaders.length > 0"
              mt-3
            >
              <v-flex
                xs4
                sm3
              >
                <p class="text-xs-left f-16 sz_grafit--text ma-0 mr-3 font-weight-bold">
                  {{ rejonLeadersTitle }}:
                </p>
              </v-flex>
              <v-layout wrap>
                <v-flex
                  v-for="(leader, index) in locationLeaders"
                  :key="index"
                  xs12
                  class="mb-2"
                >
                  <p class="text-xs-left f-16 sz_grafit--text ma-0">
                    {{ leader.full_name }}
                  </p>
                  <p class="text-xs-left f-16 sz_grafit--text ma-0">
                    {{ leader.phone | phone }}
                  </p>
                  <v-divider
                    v-if="index !== locationLeaders.length - 1"
                    class="mt-1"
                  />
                </v-flex>
              </v-layout>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions class="py-4">
        <v-layout
          align-center
          class=""
          :column="$vuetify.breakpoint.xsOnly"
          :justify-end="$vuetify.breakpoint.smAndUp"
        >
          <v-flex
            order-xs2
            order-sm1
            class="lh-1"
            shrink
            :class="[$vuetify.breakpoint.xs ? 'mt-3' : 'mr-4']"
          >
            <a
              v-if="routerReturnName === 'add-family'"
              @click="close('families-to-accept')"
            >
              <v-icon>chevron_left</v-icon>
              {{ $t('buttons.return_to_families_list') }}</a>
          </v-flex>
          <v-flex
            order-xs1
            order-sm2
            shrink
          >
            <v-btn
              color="sz_violet"
              @click="close(routerReturnName)"
            >
              {{ primaryButtonTitle }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import filters from '@/constants/filters';
import httpStatusCode from 'http-status-codes';

export default {
    name: 'FamilyDuplicate',
    filters: {
        ...filters
    },
    props: {
        value: {
            type: Boolean
        },
        routerReturnName: {
            type: String,
            default: 'add-family'
        }
    },
    data: () => ({
        showDialog: false,
        responseData: null,
        httpStatusCode
    }),
    computed: {
        creator () {
            return this.responseData && this.responseData.creator;
        },
        fullName () {
            return this.creator && this.creator.full_name;
        },
        email () {
            return this.creator && this.creator.email;
        },
        locationLeaders () {
            return this.$store.getters['familyData/getLocationLeaders'];
        },
        locationNameByWioStruct () {
            return this.$store.getters['familyData/getLocationNameByWioStruct'];
        },
        rejonLeadersTitle () {
            if (this.locationLeaders && this.locationLeaders.length > 1) {
                return this.$t('message.area_leaders');
            }
            return this.$t('message.area_leader');
        },
        primaryButtonTitle () {
            return this.routerReturnName === 'add-family'
                ? this.$t('buttons.add_next_family')
                : this.$t('buttons.ok');
        }
    },
    created () {
        this.checkDuplicate();
    },
    methods: {
        close (routeName = null) {
            this.showDialog = false;
            this.$store.commit('familyData/clearFormData');
            this.$emit('stop');
            this.$emit('duplicateFound');
            if (routeName) {
                this.$router.push({ name: routeName });
            }
        },
        checkSimilarCurrentEdition () {
            this.$emit('next');
        },
        checkDuplicate () {
            this.$store.dispatch('familyData/checkDuplicateInCurrentEdition').then((response) => {
                const status = response?.response?.status;
                if (status === this.httpStatusCode.NOT_FOUND) {
                    this.checkSimilarCurrentEdition();
                } else {
                    this.responseData = response?.data;
                    this.showDialog = true;
                    this.$emit('finish');
                }
            });
        }
    }
};
</script>

<style scoped></style>
